/* eslint-disable no-magic-numbers */

// prenos exifu z webp do jpegu vytvoreneho na canvasu (canvas exif zahodi)

// "Exif\0\0" - v jpegu je pred TIFF daty povinny, ve webp chunku byt nemusi
const EXIF_HEADER = [0x45, 0x78, 0x69, 0x66, 0x00, 0x00];
const RIFF_HEADER_SIZE = 12;
const CHUNK_HEADER_SIZE = 8;
const ORIENTATION_TAG = 0x0112;
const IFD_ENTRY_SIZE = 12;
// "II" - little endian
const TIFF_LITTLE_ENDIAN = 0x4949;
const JPEG_SOI = 0xFFD8;
const JPEG_APP0 = 0xFFE0;
const JPEG_APP1 = 0xFFE1;
// max. delka segmentu v jpegu (vcetne 2 bajtu delky)
const JPEG_MAX_SEGMENT_SIZE = 0xFFFF;

function getAscii(buffer: ArrayBuffer, offset: number) {
	return String.fromCharCode(...new Uint8Array(buffer, offset, 4));
}

/**
 * TIFF data exifu z webp (chunk "EXIF"), null kdyz nejde o webp nebo exif nema.
 */
export function getWebpExif(buffer: ArrayBuffer): Uint8Array | null {
	if (buffer.byteLength < RIFF_HEADER_SIZE || getAscii(buffer, 0) !== "RIFF" || getAscii(buffer, 8) !== "WEBP") {
		return null;
	}

	const view = new DataView(buffer);
	let offset = RIFF_HEADER_SIZE;

	while (offset + CHUNK_HEADER_SIZE <= buffer.byteLength) {
		const size = view.getUint32(offset + 4, true);
		const dataOffset = offset + CHUNK_HEADER_SIZE;

		if (getAscii(buffer, offset) === "EXIF") {
			let exif = new Uint8Array(buffer, dataOffset, Math.min(size, buffer.byteLength - dataOffset));

			if (EXIF_HEADER.every((byte, ind) => exif[ind] === byte)) {
				exif = exif.subarray(EXIF_HEADER.length);
			}

			return exif.slice();
		}

		// chunky jsou zarovnane na sudy pocet bajtu
		offset = dataOffset + size + (size % 2);
	}

	return null;
}

/**
 * Canvas fotku uz otocil podle exifu - orientaci nastavime na 1, jinak by se v jpegu otocila podruhe.
 */
function resetOrientation(tiff: Uint8Array) {
	const view = new DataView(tiff.buffer, tiff.byteOffset, tiff.byteLength);
	const littleEndian = view.getUint16(0) === TIFF_LITTLE_ENDIAN;
	const ifdOffset = view.getUint32(4, littleEndian);
	const count = view.getUint16(ifdOffset, littleEndian);

	for (let ind = 0; ind < count; ind++) {
		const entryOffset = ifdOffset + 2 + (ind * IFD_ENTRY_SIZE);

		if (view.getUint16(entryOffset, littleEndian) === ORIENTATION_TAG) {
			view.setUint16(entryOffset + 8, 1, littleEndian);
			break;
		}
	}
}

/**
 * Vlozi exif (TIFF data) do jpegu jako APP1 segment - za SOI, pripadne za APP0 (JFIF).
 * Kdyz se exif nevejde do segmentu nebo jde o neplatna data, vrati jpeg beze zmeny.
 */
export async function addJpegExif(jpeg: Blob, tiff: Uint8Array): Promise<Blob> {
	const segmentSize = 2 + EXIF_HEADER.length + tiff.length;

	if (segmentSize > JPEG_MAX_SEGMENT_SIZE) {
		return jpeg;
	}

	try {
		const exifData = tiff.slice();

		resetOrientation(exifData);

		const jpegData = new Uint8Array(await jpeg.arrayBuffer());
		const jpegView = new DataView(jpegData.buffer);

		if (jpegView.getUint16(0) !== JPEG_SOI) {
			return jpeg;
		}

		const insertOffset = jpegView.getUint16(2) === JPEG_APP0
			? 4 + jpegView.getUint16(4)
			: 2;
		const app1 = new Uint8Array(2 + segmentSize);
		const app1View = new DataView(app1.buffer);

		app1View.setUint16(0, JPEG_APP1);
		app1View.setUint16(2, segmentSize);
		app1.set(EXIF_HEADER, 4);
		app1.set(exifData, 4 + EXIF_HEADER.length);

		return new Blob([jpegData.subarray(0, insertOffset), app1, jpegData.subarray(insertOffset)], { type: "image/jpeg" });
	} catch (exc) {
		/* eslint-disable-next-line */
		console.log(exc);

		return jpeg;
	}
}
